import React, { useState } from 'react';

const GlediCoComponent = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  return (
    <div className="app-container">
      <header className="header">
        <div className="header-left">
          <div className="logo">GlediCo</div>
          <nav className="nav">
            <div className="dropdown">
              <button 
                className="dropdown-toggle" 
                onClick={toggleDropdown}
                onBlur={() => setTimeout(closeDropdown, 100)}
              >
                Application
                <svg className={`dropdown-arrow ${isDropdownOpen ? 'open' : ''}`} width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <div className={`dropdown-menu ${isDropdownOpen ? 'show' : ''}`}>
                <a href="https://gledico.no/goflow" className="dropdown-item">
                  Flow diagram maker
                </a>
                <a href="https://gledico.no/mpview" className="dropdown-item">
                  Eventviewer
                </a>
              </div>
            </div>
          </nav>
        </div>
      </header>
      
      <main>
        <div className="light"></div>
        <figure>
          <div className="text">
            {Array(20).fill().map((_, index) => (
              <span key={index}></span>
            ))}
          </div>
          <span className="shadow"></span>
        </figure>
      </main>

      <style jsx="true">{`
        @import url("https://fonts.googleapis.com/css2?family=Lobster&display=swap");
        
        .app-container {
          height: 100vh;
          width: 100vw;
          position: relative;
        }
        
        body {
          height: 100vh;
          margin: 0;
          background-color: #333;
          font-family: Lobster, "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
            "Lucida Sans", Arial, sans-serif;
        }

        /* Header styles */
        .header {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 60px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 2rem;
          background-color: rgba(11, 14, 19, 0.9);
          backdrop-filter: blur(10px);
          z-index: 100;
          box-shadow: 0 2px 15px rgba(0, 0, 0, 0.5);
        }
        
        .header-left {
          display: flex;
          align-items: center;
          gap: 2rem;
        }

        .logo {
          font-size: 2rem;
          color: #7da8dd;
          text-shadow: 0 0 10px rgba(125, 168, 221, 0.5);
          letter-spacing: 1px;
        }

        .nav {
          display: flex;
          align-items: center;
        }

        .dropdown {
          position: relative;
        }

        .dropdown-toggle {
          display: flex;
          align-items: center;
          gap: 8px;
          background: none;
          border: none;
          color: #fff;
          font-family: inherit;
          font-size: 1.1rem;
          padding: 8px 16px;
          cursor: pointer;
          border-radius: 4px;
          background-color: rgba(125, 168, 221, 0.1);
          transition: all 0.2s ease;
        }

        .dropdown-toggle:hover {
          background-color: rgba(125, 168, 221, 0.2);
        }

        .dropdown-arrow {
          transition: transform 0.2s ease;
        }

        .dropdown-arrow.open {
          transform: rotate(180deg);
        }

        .dropdown-menu {
          position: absolute;
          top: 100%;
          right: 0;
          min-width: 200px;
          background-color: rgba(22, 28, 38, 0.95);
          backdrop-filter: blur(10px);
          border-radius: 4px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
          margin-top: 8px;
          opacity: 0;
          visibility: hidden;
          transform: translateY(-10px);
          transition: all 0.2s ease;
          z-index: 101;
          overflow: hidden;
        }

        .dropdown-menu.show {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
        }

        .dropdown-item {
          display: block;
          padding: 12px 16px;
          color: #e0e0e0;
          text-decoration: none;
          font-size: 1rem;
          transition: all 0.2s ease;
          border-left: 3px solid transparent;
        }

        .dropdown-item:hover {
          background-color: rgba(125, 168, 221, 0.15);
          color: #fff;
          border-left: 3px solid #7da8dd;
        }

        main {
          --text: "GlediCo";
          --hue: 210deg;
          --spin: 25deg;
          --light-color: #7da8dd; /* darker blue light */
          --perspective: 80vmin;
          --stripe: 0.3em;
          --stripe-angle: -35deg;
          width: 100%;
          height: 100%;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          background-image: linear-gradient(
            to bottom,
            #383838,
            #3c3c3c 50%,
            #2f2f2f 60%,
            #0b0e13
          );
          font-size: 17.5vmin;
        }
        
        main .light {
          display: block;
          position: absolute;
          top: 0;
          left: 50%;
          width: 90%;
          height: 60%;
          min-height: 6em;
          transform: translateX(-50%) translateY(-1em);
          z-index: 1;
          mix-blend-mode: screen;
          filter: blur(0.2em);
          opacity: 0.4; /* reduced brightness */
        }
        
        main .light::before {
          content: "";
          display: block;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-image: linear-gradient(to bottom, var(--light-color), transparent);
          clip-path: polygon(25% 0, 75% 0, 100% 100%, 0% 100%);
          border-radius: 0 0 1em 1em;
        }
        
        main figure {
          display: block;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          transform-style: preserve-3d;
          perspective: var(--perspective);
        }
        
        main figure span {
          display: block;
        }
        
        main figure span::before {
          text-align: center;
          content: var(--text);
          white-space: pre;
          display: block;
        }
        
        main figure .text {
          animation: rotate 3s ease-in-out infinite both alternate;
          transform-style: preserve-3d;
          position: relative;
        }
        
        main figure .text span {
          transform-style: preserve-3d;
          position: absolute;
          top: 0;
          left: 0;
        }
        
        main figure .text span:first-child {
          position: static;
          animation: shine 3s linear infinite;
        }
        
        main figure .text span:nth-child(1)::before {
          transform: translateZ(-0.01em);
          color: hsl(var(--hue), 59%, 77.5%);
        }
        main figure .text span:nth-child(2)::before {
          transform: translateZ(-0.02em);
          color: hsl(var(--hue), 58%, 75%);
        }
        main figure .text span:nth-child(3)::before {
          transform: translateZ(-0.03em);
          color: hsl(var(--hue), 57%, 72.5%);
        }
        main figure .text span:nth-child(4)::before {
          transform: translateZ(-0.04em);
          color: hsl(var(--hue), 56%, 70%);
        }
        main figure .text span:nth-child(5)::before {
          transform: translateZ(-0.05em);
          color: hsl(var(--hue), 55%, 67.5%);
        }
        main figure .text span:nth-child(6)::before {
          transform: translateZ(-0.06em);
          color: hsl(var(--hue), 54%, 65%);
        }
        main figure .text span:nth-child(7)::before {
          transform: translateZ(-0.07em);
          color: hsl(var(--hue), 53%, 62.5%);
        }
        main figure .text span:nth-child(8)::before {
          transform: translateZ(-0.08em);
          color: hsl(var(--hue), 52%, 60%);
        }
        main figure .text span:nth-child(9)::before {
          transform: translateZ(-0.09em);
          color: hsl(var(--hue), 51%, 57.5%);
        }
        main figure .text span:nth-child(10)::before {
          transform: translateZ(-0.1em);
          color: hsl(var(--hue), 50%, 55%);
        }
        main figure .text span:nth-child(11)::before {
          transform: translateZ(-0.11em);
          color: hsl(var(--hue), 49%, 52.5%);
        }
        main figure .text span:nth-child(12)::before {
          transform: translateZ(-0.12em);
          color: hsl(var(--hue), 48%, 50%);
        }
        main figure .text span:nth-child(13)::before {
          transform: translateZ(-0.13em);
          color: hsl(var(--hue), 47%, 47.5%);
        }
        main figure .text span:nth-child(14)::before {
          transform: translateZ(-0.14em);
          color: hsl(var(--hue), 46%, 45%);
        }
        main figure .text span:nth-child(15)::before {
          transform: translateZ(-0.15em);
          color: hsl(var(--hue), 45%, 42.5%);
        }
        main figure .text span:nth-child(16)::before {
          transform: translateZ(-0.16em);
          color: hsl(var(--hue), 44%, 40%);
        }
        main figure .text span:nth-child(17)::before {
          transform: translateZ(-0.17em);
          color: hsl(var(--hue), 43%, 37.5%);
        }
        main figure .text span:nth-child(18)::before {
          transform: translateZ(-0.18em);
          color: hsl(var(--hue), 42%, 35%);
        }
        main figure .text span:nth-child(19)::before {
          transform: translateZ(-0.19em);
          color: hsl(var(--hue), 41%, 32.5%);
        }
        main figure .text span:nth-child(20)::before {
          transform: translateZ(-0.2em);
          color: hsl(var(--hue), 40%, 30%);
        }
        
        main figure .shadow {
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          transform-style: preserve-3d;
          perspective: var(--perspective);
          width: 90vw;
          height: 90vw;
          font-size: 1em;
          transform: translate3D(0, 2em, 0) rotateX(90.01deg);
          opacity: 0.9;
          backface-visibility: hidden;
        }
        
        main figure .shadow::after {
          content: "";
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-image: radial-gradient(
            closest-side,
            var(--light-color),
            transparent
          );
          transform: translateY(1px);
          z-index: 0;
          mix-blend-mode: screen;
          opacity: 0.4; /* reduced shadow opacity */
        }
        
        main figure .shadow-text {
          position: absolute;
          font-size: 1em; /* Match the main text size */
          color: rgba(125, 168, 221, 0.7);
          text-shadow: 0 0 5px rgba(125, 168, 221, 0.5);
          transform: translate3D(0, 2em, 0) rotateX(90deg);
          font-family: Lobster, "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
            "Lucida Sans", Arial, sans-serif; /* Match the main font */
          text-transform: lowercase;
          letter-spacing: 0.2em;
          z-index: 3;
          width: 100%;
          text-align: center;
          animation: float 4s ease-in-out infinite;
        }
        
        @keyframes float {
          0%, 100% {
            transform: translate3D(0, 2em, 0) rotateX(90deg) translateY(0);
          }
          50% {
            transform: translate3D(0, 2em, 0) rotateX(90deg) translateY(-10px);
          }
        }
        
        main figure .shadow::before {
          content: "koding";
          filter: blur(4px);
          opacity: 0.8;
          animation: rotate-shadow 3s ease-in-out infinite both alternate;
          z-index: 1;
          position: absolute;
          display: block;
          text-align: center;
          width: 100%;
        }
        
        @media not all and (min-resolution: 0.001dpcm) {
          main figure .shadow::before {
            filter: none;
            opacity: 0.6;
          }
        }

        @keyframes rotate {
          from {
            transform: rotate3D(0, 1, 0, calc(var(--spin) * -1)) rotateX(30deg);
          }
          to {
            transform: rotate3D(0, 1, 0, var(--spin)) rotateX(30deg);
          }
        }
        
        @keyframes rotate-shadow {
          from {
            transform: rotateZ(var(--spin));
          }
          to {
            transform: rotateZ(calc(var(--spin) * -1));
          }
        }
        
        @keyframes shine {
          0% {
            filter: brightness(1);
          }
          30% {
            filter: brightness(1.2);
          }
          50% {
            filter: brightness(1.4);
          }
          70% {
            filter: brightness(1.2);
          }
          100% {
            filter: brightness(1);
          }
        }
      `}</style>
    </div>
  );
};

export default GlediCoComponent;